module.exports = __webpack_public_path__ + "static/img/phone_ico_bottom_qrcode.ba69573.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/big_picture/phone_ico_bottom_qrcode.png
// module id = GCb1
// module chunks = 0